import { Routes, Route, BrowserRouter } from "react-router-dom";

import HomePage from "./pages/home/HomePage";
import ProductsPage from "./pages/products/ProductsPage";
import AdminPage from "./pages/admin/AdminPage";
import LoginAdmin from "./pages/loginAdmin/LoginPage";
import LoginUser from "./pages/loginUser/LoginPage";
import DetailProductPage from "./pages/detailProducts/DetailProductPage";
import UserProfile from "./pages/userProfile/UserProfile";
import LocationPage from "./pages/location/LocationPage";
import DocumentationPage from "./pages/documentation/DocumentationPage";

const Router = (props) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<HomePage />} />
          <Route path="connexion/admin" element={<LoginAdmin />} />
          <Route path="connexion/user" element={<LoginUser />} />
          <Route path="localisation" element={<LocationPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="documentation" element={<DocumentationPage />} />
          <Route path="user/:id" element={<UserProfile />} />
          <Route path="produits">
            <Route index element={<ProductsPage />} />
            <Route path=":id" element={<DetailProductPage />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
